export default "__VITE_ASSET__DjNwqvlX__"